import React from "react";
import {Col, ListGroup, Row} from "react-bootstrap";

interface MessageListItemProps {
    name: string,
    value: string
}

export const MessageListItem = ({name, value}: MessageListItemProps) =>
    <ListGroup.Item style={{color: '#e30171', fontWeight: 'bold'}}>
        <Row>
            <Col sm={4}>
                <span style={{color: '#9b99ce'}}>{name}:</span>
            </Col>
            <Col>
                <span>{value}</span>
            </Col>
        </Row>
    </ListGroup.Item>;
